import { createContext, ReactNode, useMemo, useReducer } from "react";
import playgroundSlice, { initialState } from "./playgroundSlice";
import { PlaygroundContextProps } from "./types";
import GlobalPlaygroundButton from "./components/GlobalPlaygroundButton";

export const PlaygroundContext = createContext<PlaygroundContextProps>({
  state: initialState,
  dispatch: () => null,
});

const PlaygroundProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [state, dispatch] = useReducer(playgroundSlice.reducer, playgroundSlice.getInitialState());

  const values = useMemo(
    () => ({
      state,
      dispatch,
    }),
    [state]
  );

  return (
    <PlaygroundContext.Provider value={values}>
      {children}
      <GlobalPlaygroundButton key={"global-playground"} />
    </PlaygroundContext.Provider>
  );
};

export default PlaygroundProvider;
